import * as type from './mainActionTypes';

export const setShowMobileMenu = (show) => ({
  type: type.SET_SHOW_MOBILE_MENU,
  show,
});

export const getShowMobileMenu = () => ({
  type: type.GET_SHOW_MOBILE_MENU,
});
